import React, { useEffect } from "react";
import { useHistory } from "react-router-dom";
import { Button, Table } from "react-bootstrap";
import { DEBUG } from "../../App";
import { compareSemesters } from "../../util";
import { setMessage } from "../../state/slices/message";
import { useDispatch, useSelector } from "react-redux";
import {
  clearApplications,
  setApplications,
} from "../../state/slices/application";
import { useGetAllHiringSeasonsQuery } from "../../state/services/hiring";
import { useLazyGetAllApplicationsQuery } from "../../state/services/applications";

const NOT_APPLIED = "Not applied";

// Show a table to a student that lists hiring seasons.
// If the student applied for a hiring season, then get the option to view their application
// Otherwise, they get the option to apply for that season (unless application is closed)
export default function ApplicationTable(props) {
  const applications = useSelector((state) => state.applications.records);
  const userInfo = useSelector((state) => state.auth.userInfo);
  const dispatch = useDispatch();
  const history = useHistory();

  const { data: hiringSeasons } = useGetAllHiringSeasonsQuery();

  const [getAllApplications, _result, _lastPromiseInfo] =
    useLazyGetAllApplicationsQuery();

  useEffect(() => {
    if (
      !hiringSeasons ||
      hiringSeasons.length === 0 ||
      !userInfo ||
      !userInfo.jhed
    ) {
      dispatch(clearApplications());
      return;
    }

    const getData = async () => {
      try {
        // The following code fetches the student's application for every hiring season
        // if exists! This is done so we are able to show which hiring seasons
        // the student is applied for (so they can open the old application in view mode)
        // Moreover, it prepares the application for a new hiring season to be opened in edit mode.
        const applicationsArr = [];
        for (const season of hiringSeasons) {
          const filter = {
            year: season.year,
            term: season.term,
            jhed: userInfo.jhed,
          };

          let { data: application } = await getAllApplications(filter);

          if (application.length === 0) {
            // FIXME: hiring seasons before user joined the system must be discarded!
            //  Or keep track of the last four years for example!
            //  The point is to avoid having a very long table in here!
            application = [
              {
                year: season.year,
                term: season.term,
                jhed: userInfo.jhed,
                status: NOT_APPLIED,
              },
            ];
          }
          applicationsArr.push(...application);
        }

        applicationsArr.sort((app1, app2) => compareSemesters(app1, app2));
        dispatch(setApplications(applicationsArr));
      } catch (err) {
        DEBUG && console.log("Error:", err);
        DEBUG && console.log("Error Response:", err.error);

        const msg =
          (err && err.error && err.error.data && err.error.data.message) ||
          "An error has occurred when reading your application data.";
        dispatch(
          setMessage({ text: msg, error: JSON.stringify(err, null, 2) })
        );
      }
    };

    getData();
  }, [userInfo, hiringSeasons, dispatch]);

  return (
    <div className="section container text-left">
      <h3>Applications</h3>
      <Table striped bordered responsive>
        <thead>
          <tr>
            <th style={{ width: "25%" }}>Year</th>
            <th style={{ width: "25%" }}>Term</th>
            <th style={{ width: "25%" }}>Status</th>
            <th style={{ width: "25%" }}>Action</th>
          </tr>
        </thead>
        <tbody>
          {applications &&
            applications.map((app, index) => {
              return (
                <tr key={index}>
                  <td className="align-middle">{app.year}</td>
                  <td className="align-middle">{app.term}</td>
                  <td className="align-middle">{app.status}</td>
                  <td className="align-middle">
                    {action(app, history, hiringSeasons)}
                  </td>
                </tr>
              );
            })}
        </tbody>
      </Table>
    </div>
  );
}

export function hiringSeasonIsOpen(year, term, hiringSeasons) {
  // FIXME there was a strange bug where hiringSeasons was undefined
  //   but we cannot reproduce it.
  if (!hiringSeasons || hiringSeasons.length === 0) return false;

  const season = hiringSeasons.find(
    (season) => season.year === year && season.term === term
  );

  return season && season.status === "Open";
}

function action(app, history, hiringSeasons) {
  switch (app.status) {
    case NOT_APPLIED:
      if (hiringSeasonIsOpen(app.year, app.term, hiringSeasons)) {
        return (
          <Button
            variant="primary"
            block
            size="sm"
            onClick={() => {
              history.push(
                `/applications?year=${app.year}&term=${app.term}&jhed=${app.jhed}`
              );
            }}
          >
            Submit
          </Button>
        );
      } else {
        return (
          <Button disabled variant="primary" block size="sm">
            Submission is closed
          </Button>
        );
      }
    default:
      return (
        <Button
          variant="info"
          block
          size="sm"
          onClick={() => {
            history.push(`/applications?id=${app._id}`);
          }}
        >
          View
        </Button>
      );
  }
}
